import { render, staticRenderFns } from "./DeductionsPlanDetailsDelete.vue?vue&type=template&id=cdc7faf0&scoped=true&"
import script from "./DeductionsPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc7faf0",
  null
  
)

export default component.exports